import { APIRoute } from '@/modules/utils'
import { PartnerQuote } from '@/data'
import { HydraCollection } from 'emt-library'

export const Route: APIRoute = {
  method: 'GET',
  path: `/v2/partners/quote`,
}

export type Response = HydraCollection<PartnerQuote>
